/**
 * Doctor node full.
 */
class DoctorFull extends DrupalBehavior {
    onReady(document) {

      // Doctor menu mobile;
      if ($('#block-sidebarmenu').length) {
        const $doctorMenu = $('#block-sidebarmenu .contextual-region > ul').clone();
        const $blockTitle = $('#block-sidebarmenu > a').text();

        const $mobileMenu = $('<div></div>').addClass('doctor-mobile-menu');
        const $mobileMenuWrapper = $('<div></div>').addClass('doctor-mobile-menu__wrapper');
        const $menuButton = $('<button></button>').addClass('doctor-mobile-menu__button');

        $menuButton.text($blockTitle);
        $menuButton.on('click', (event) => {
          event.preventDefault();
          $mobileMenu.toggleClass('doctor-mobile-menu--active');
          $mobileMenu.find('ul li a').on('click', function(e) {
            $mobileMenu.removeClass('doctor-mobile-menu--active');
          });
        });

        $mobileMenuWrapper.append($doctorMenu);
        $mobileMenu.append($menuButton);
        $mobileMenu.append($mobileMenuWrapper);
        $mobileMenu.insertBefore($('section.banner'));
      }
    }
  }

  DrupalBehavior.register('camc.pages', 'doctor full', DoctorFull);
